import { grey } from '@material-ui/core/colors';
import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => {
	return {
		modal: {
			position: 'absolute',
			top: 50,
			padding: '30px 20px 20px 20px',
			height: '100%'
		},
		title: {
			marginBottom: 25,
			alignItems: 'center',
			fontSize: 22
		},
		filterIcon: {
			marginRight: 10
		},
		closeIcon: {
			color: grey[600],
			fontSize: 18,
			marginLeft: 'auto',
			cursor: 'pointer'
		},
		loadingContainer: {
			position: 'absolute',
			top: '50%',
			left: '50%',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center'
		},
		filterContainer: {
			paddingBottom: 20
		}
	};
});
